import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/docxRenderer/styles.scss';export default {
  "renderer": "_renderer_nv8r2_1",
  "content": "_content_nv8r2_9"
};